import { useState } from "react";
import { Box, Typography, useTheme, Skeleton } from "@mui/material";
import { Add } from "@mui/icons-material";
import { AddAmbassadorModal } from "@/modules/ambassadors/components/add-ambassador-modal";
import { NwButton } from "@nawy/ui";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";

interface AmbassadorHeaderProps {
  title?: string;
  count?: number;
  loading?: boolean;
}

export function AmbassadorHeader({
  title = "Ambassadors",
  count = 0,
  loading = false,
}: AmbassadorHeaderProps) {
  const theme = useTheme();
  const { isMobile } = useScreenSize();
  const [open, setOpen] = useState(false);

  const renderCount = () => {
    if (typeof count !== "number") return null;

    return (
      <Box
        component="span"
        sx={{
          ml: isMobile ? 0 : 1,
          mt: isMobile ? 0.5 : 0,
          ...theme.nawy.typography.english.variants.body.sm.regular,
          color: theme.nawy.colors.semantic.text.primary,
          display: "flex",
          alignItems: "center",
          minWidth: "80px",
        }}
      >
        {loading ? (
          <Skeleton
            variant="rounded"
            width={60}
            height={15}
            sx={{
              borderRadius: "12px",
              bgcolor: theme.nawy.colors.semantic.layer.tertiary,
            }}
          />
        ) : (
          `(${count} ambassadors)`
        )}
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          flexDirection: "row",
          gap: isMobile ? 1 : 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: isMobile ? "wrap" : "nowrap",
            alignItems: isMobile ? "flex-start" : "center",
          }}
        >
          <Typography
            sx={{
              ...theme.nawy.typography.english.variants.headline.sm,
              color: theme.nawy.colors.semantic.text.primary,
            }}
          >
            {title}
          </Typography>
          {renderCount()}
        </Box>

        <Box>
          <NwButton startIcon={<Add />} onClick={() => setOpen(true)}>
            Add Ambassador
          </NwButton>
          <AddAmbassadorModal open={open} onClose={() => setOpen(false)} />
        </Box>
      </Box>
    </Box>
  );
}
